import { device } from '@/utils/index'

const content = [
    // 第一章 第三节 Enriching Your Ideas Text A
    // 章标题
    {
        key: 'section3',
        type: "title",
        category: 1, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: "第<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        // text: '文旌数字教材', // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/chapterImage2.png"), // 标题图片
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
        }
    },
    {
        key: 'section3.1',
        type: 'template',
        category: 2, // *必填* 分类 1：单个带边框 2：两级tabs
        content: [{
                key: 'section3.1.1',
                type: 'tab1',
                text: 'Text A',
                content: [{
                        key: 'section3.1.1.1',
                        type: 'tab2',
                        text: 'Text A',
                        width: 105,
                        content: [
                            //展开收起title
                            {
                                key: 'section3.1.1.1.1',
                                type: 'template',
                                category: 3, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                                templateStyle: {
                                    margin: 0,
                                },
                                title: '中文翻译',
                                titleStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    // marginTop: 30,
                                    // marginBottom: 30,
                                    // padding: 0,
                                    // paddingTop: 20,
                                    // paddingBottom: 0,
                                    // borderRadius: 0,
                                    // border: '',
                                    // borderTop: '',
                                    // borderBottom: ''
                                },
                                content: [
                                    {
                                        key: 'section3.1.1.1.1.1', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文
                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.1.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '春节对你来说意味着什么？对大多数人来说，春节象征着家庭团聚、幸福和美好的期待。但对我而言，有时春节却像一种负担', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',

                                                    // fontWeight: 'bold'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#111', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.2', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.2.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '去年春节，我像往常一样踏上了回家的路。尽管路途遥远，而且预计会有交通拥堵，但我的内心深处仍有一丝抗拒。想到要面对拥挤的道路和混乱的准备工作，我不禁怀疑这一切是否值得。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.3', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.3.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '不出所料，回家的旅途非常艰辛。我坐在车里好几个小时，几乎寸步难移，随着时间的流逝，沮丧情绪越来越强烈。就在我几近绝望之际，电话响了，是父母打来的。他们温暖的声音充满了温暖和爱意，提醒我慢慢来，不要急。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#111', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.4', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.4.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '他们的话深深触动了我。我意识到，无论旅程多么不便、多么疲惫，都是为了在这个特殊的时刻与所爱的人团聚。他们的理解与支持，让我重新找到了动力。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.5', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.5.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '终于，在感觉像是度过了漫长的岁月之后，我回到了家。当我走进前门时，迎接我的是我母亲烹饪时那令人安心的香气。房子里充满了欢声笑语。尽管年事已高，我的父母还是熬到很晚，只为了迎接我回家。他们紧紧拥抱我时，眼中满是喜悦和爱意。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.6', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.6', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '那一刻，旅途中所有的疲惫和沮丧都烟消云散了。我意识到，春节真正的意义在于我们与家人之间所分享的爱和联系。这是一个珍惜共度时光的时刻，也是一个创造将伴随我们一生的美好回忆的时刻。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.7', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.7.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '春节期间，我发现自己喜欢上了慢节奏的生活。我不再为准备工作感到匆忙或焦虑。相反，我抓住机会与父母共度美好时光。我们一起包饺子，一边干活，一边在欢声笑语中畅聊往事。我们围在餐桌旁，边共享美食，边真诚的交谈。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.8', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.8.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '节日的气氛感染着每一个人。街道上挂满了色彩斑斓的装饰，鞭炮声不绝于耳。我与许久未见的朋友、邻居重逢，互致问候，了解彼此的生活，共同畅想新一年的期望和梦想，互相支持、鼓励。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.9', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.9.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '随着时间的流逝，我明白了春节不仅仅是对过去一年的庆祝，更是一种对未来的展望。它象征着新的开始，赋予我们成长的机会。提醒我学会放下过往的失落，迎接更光明的未来。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                    {
                                        key: 'section3.1.1.1.1.10', // *必填* 唯一标识
                                        type: 'text', // *必填* 类型：正文

                                        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                            {
                                                key: 'section3.1.1.1.1.10.1', // *必填* 唯一标识
                                                category: 'text', // *必填* 内容类型 text：文本
                                                text: '如今，春节对我而言，意味着什么呢？它意味着反思、感恩和重新来过的乐观态度。它提醒我要珍惜家人的爱和温暖，放慢脚步，欣赏生活中简单的快乐。春节教会了我，在喧嚣与挑战中，也要充满希望，迎接更美好的明天。', // *必填* 文本内容
                                                textStyle: {
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: '22px',
                                                    // fontWeight: '400'
                                                },
                                            },
                                        ],
                                        textStyle: {
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                        },
                                    },
                                ],
                                contentStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    // marginTop: 30,
                                    // marginBottom: 30,
                                    padding: 0,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    // paddingTop: 0,
                                    // paddingBottom: 0,
                                    // borderRadius: 0,
                                    // border: '',
                                    // borderTop: '',
                                    // borderBottom: ''
                                },
                            },
                            {

                                key: 'section3.1.1.1.2',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '1',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.2.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.2.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'What does the Spring Festival mean to you? For most people, the Spring Festival ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section1.12.5.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: 'symbolizes', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 2,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/02 symbolize.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section1.12.3.1.2.1',
                                                    text: 'symbolizes',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        // fontSize: 18,
                                                    }
                                                },
                                                {
                                                    key: 'section1.12.3.1.2.2',
                                                    text: '/ˈsɪmbəlaɪz/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                        // fontSize: 14,
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section1.12.3.1.2.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                    // fontSize: 14
                                                },
                                                content: [{
                                                    key: 'section1.12.3.1.2.4.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [
                                                        {
                                                            key: 'section1.12.3.1.2.4.1.1',
                                                            text: 'v.  ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // fontSize: 13,
                                                                // lineHeight: 36
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.1.2',
                                                            text: '象征；是',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.1.3',
                                                            text: '……',
                                                            textStyle: {
                                                                fontFamily: '宋体',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.1.4',
                                                            text: '的象征；代表',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                // fontSize: 13,
                                                                // lineHeight: 36,
                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.2.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'family reunion, happiness, and ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.2.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: 'anticipation', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 3,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/03 anticipation.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.2.1.4.1',
                                                    text: 'anticipation',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.2.1.4.2',
                                                    text: '/ænˌtɪsɪˈpeɪʃn/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.2.1.4.3',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.2.1.4.3.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.2.4.4.1.112',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2

                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.4.1.1121',
                                                            text: '期盼；期望；预料',
                                                            textStyle: {

                                                            },
                                                        },

                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.2.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '. However, for me, it sometimes feels like a burden.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.3',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '2',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.3.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.3.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Last year, as usual, I embarked on my journey home for the Spring Festival. Despite the long drive and the anticipated', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.3.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' traffic, I couldn’t help but feel a sense of dread. The thought of dealing with crowded roads and the chaos of preparations made me question whether it was worth all the', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.2.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' hassle', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 4,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/05 hassle.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.2.1.4.1',
                                                    text: 'hassle',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.2.1.4.2',
                                                    text: '/ˈhæsl/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.2.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.2.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.2.4.4.1.113',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.4.1.1131',
                                                            text: '困难；麻烦',
                                                            textStyle: {
                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.3.1.4', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.4',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '3',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.4.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.4.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'As expected, the journey was ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.4.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' arduous', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 5,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/06 arduous.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.4.1.2.1',
                                                    text: 'arduous',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.4.1.2.2',
                                                    text: '/ˈɑːdʒuəs/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section1.12.3.1.4.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section1.12.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.4.4.1.1.1',
                                                            text: 'adj.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.4.4.1.1.2',
                                                            text: '艰苦的；艰难的',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.4.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' . I found myself sitting in my car for hours,', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.4.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '  barely', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 6,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/07 barely.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.4.1.4.1',
                                                    text: 'barely',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.4.1.4.2',
                                                    text: '/ˈbeəli/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.4.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.4.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.2.4.4.1.113',
                                                            text: 'adv.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.4.1.1131',
                                                            text: '仅仅；勉强可能',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        }, {
                                            key: 'section3.1.1.1.4.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' moving an inch. The frustration grew as time passed by. But just when I was on the', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.4.1.6', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '   verge', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 7,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/08 verge.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.4.1.6.1',
                                                    text: ' verge',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.4.1.6.2',
                                                    text: '/vɜːdʒ/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.4.1.6.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.4.1.6.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.1.1.4.1.6.3.1.1.113',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.1.1.4.1.6.3.1.1.1131',
                                                            text: '边；边缘；边沿',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.4.1.7', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' of losing hope, my phone rang. It was my parents calling to check on me. Their voices were filled with warmth and love, reminding me to take my time and not to rush.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.5',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '4',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.5.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.5.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Their words struck a ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.5.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: 'chord', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 8,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/09 chord.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.5.1.2.1',
                                                    text: 'chord',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.5.1.2.2',
                                                    text: '/kɔːd/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.12.3.1.4.45',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.12.3.1.4.4.1.21',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.12.3.1.4.4.1.1.11',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.12.3.1.4.4.1.1.111',
                                                            text: '和弦；和音',
                                                            textStyle: {

                                                            },
                                                        },

                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.5.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '  within me. I realized that no matter how inconvenient or tiring the journey may be, it was all for the sake of being with my loved ones during this special time. Their constant support and understanding gave me a renewed sense of purpose.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.6',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '5',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.6.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Finally, after what felt like an eternity, I arrived home. As I stepped through the front door, I was greeted with the comforting ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.6.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' aroma', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 9,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/10 aroma.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.6.1.2.1',
                                                    text: 'aroma',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.6.1.2.2',
                                                    text: '/əˈrəʊmə/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.13.31.1.4.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.121.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.122.3.1.4.4.1.1.1',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.122.3.1.4.4.1.1.2',
                                                            text: '（食物等的）香味；芳香',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.6.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '  of my mother’s cooking. The house was filled with laughter and joy. My parents, despite their old age, had stayed up late just to welcome me. Their eyes', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.6.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '  sparkled', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 10,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/11 sparkle.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.6.1.4.1',
                                                    text: 'sparkled',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.6.1.4.2',
                                                    text: '/ˈspɑːkl/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.4.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.4.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.2.4.4.1.113',
                                                            text: 'v.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.2.4.4.1.1131',
                                                            text: '闪烁；闪耀',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.6.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.7',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '6',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.7.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.7.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'At that moment, all the ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.7.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' weariness', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 11,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/12 weariness.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.7.1.2.1',
                                                    text: 'weariness',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.7.1.2.2',
                                                    text: '/ˈwɪərinəs/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.127.3.1.4.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.127.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.127.3.1.4.4.1.1.1',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.127.3.1.4.4.1.1.2',
                                                            text: '疲倦；疲劳；厌倦',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.7.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' and frustration of the journey', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.7.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '  melted', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 12,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/13 melt.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.7.1.4.1',
                                                    text: 'melt',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.7.1.4.2',
                                                    text: '/melt/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.4.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.7.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.18.3.1.2.4.4.1.113',
                                                            text: 'v.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.18.3.1.2.4.4.1.1131',
                                                            text: '熔化；融化',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        }, {
                                            key: 'section3.1.1.1.7.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' away. I realized that the true meaning of the Spring Festival lies in the love and connection we share with our family. It is a time to cherish the moments spent together and to create memories that will last a lifetime.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.8',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '7',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.8.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.8.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'During the Spring Festival, I found myself enjoying the slower pace of life. I no longer felt rushed or anxious about the preparations. Instead, I embraced the opportunity to spend quality time with my parents. We made dumplings together, sharing stories and laughter as we worked. We sat around the table, enjoying delicious meals and engaging in ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.8.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: 'heartfelt', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 13,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/14 hearelt.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.8.1.2.1',
                                                    text: 'heartfelt',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.8.1.2.2',
                                                    text: '/ˈhɑːtfelt/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.128.3.1.8.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.128.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.128.3.1.4.4.1.1.1',
                                                            text: 'adj.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.128.3.1.4.4.1.1.2',
                                                            text: '真诚的；衷心的',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.8.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '  conversations.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },


                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.9',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '8',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.9.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.9.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'The ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.9.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' festive', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 14,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/15 festive.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.9.1.2.1',
                                                    text: 'festive',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.9.1.2.2',
                                                    text: '/ˈfestɪv/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.129.3.1.4.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.129.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.129.3.1.4.4.1.1.1',
                                                            text: 'adj.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.129.3.1.4.4.1.1.2',
                                                            text: '节日的；喜庆的；欢乐的',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.9.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '  atmosphere was contagious. The streets were ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.9.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '  adorned', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 15,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/16 adorn.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.9.1.4.1',
                                                    text: 'adorn',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.9.1.4.2',
                                                    text: '/əˈdɔːn/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.9.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.9.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.129.3.1.2.4.4.1.113',
                                                            text: 'v.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.129.3.1.2.4.4.1.1131',
                                                            text: '装饰；装扮',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        }, {
                                            key: 'section3.1.1.1.9.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' with vibrant decorations, and the sound of firecrackers filled the air. I', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.9.1.6', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '    reunited', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 16,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/17 reunite.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.9.1.6.1',
                                                    text: ' reunite',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.9.1.6.2',
                                                    text: '/ˌriːjuˈnaɪt/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.9.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.9.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.129.3.1.2.4.4.1.113',
                                                            text: 'v.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.129.3.1.2.4.4.1.113',
                                                            text: '（使）团聚；（使）团圆',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.9.1.7', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '  with old friends and neighbors, exchanging well wishes and catching up on each other’s lives. We shared our hopes and dreams for the upcoming year, supporting and encouraging one another.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.10',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '9',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.10.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.10.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'As the days passed, I realized that the Spring Festival was not just a celebration of the past year but a hopeful anticipation of what lies ahead. It symbolized new beginnings and a chance for personal growth. It reminded me to let go of any past disappointments and embrace the possibilities of a brighter future.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {

                                key: 'section3.1.1.1.11',
                                type: 'paragraph',
                                category: 'withBefore',

                                leftMark: { // 左侧标记

                                    type: 'inline', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 40,
                                    height: 40,

                                    text: '10',

                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体

                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40,

                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        marginLeft: 0,

                                        marginRight: 0,
                                        marginTop: 0,

                                        marginBottom: 0,

                                        top: 0,

                                        left: 0,

                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.1.1.11.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.1.1.11.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'What does the Spring Festival mean to me now? It is a time of reflection, gratitude, and renewed ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.11.1.2', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: ' optimism', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 17,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/18 optimism.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.11.1.2.1',
                                                    text: 'optimism',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.11.1.2.2',
                                                    text: '/ˈɒptɪmɪzəm/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1211.3.1.4.4',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1211.3.1.4.4.1.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section1.12.3.1.4.4.1.1.1',
                                                            text: 'n.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section1.12.3.1.4.4.1.1.2',
                                                            text: '乐观；乐观主义',
                                                            textStyle: {

                                                            },
                                                        },
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        },
                                        {
                                            key: 'section3.1.1.1.11.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' . It is a reminder to cherish the love and warmth of family, to slow down, and to appreciate the simple joys in life. The Spring Festival has taught me that', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },
                                        {
                                            key: 'section3.1.1.1.11.1.4', // *必填* 唯一标识
                                            category: 'popover', // *必填* 内容类型 text：文本
                                            text: '  amid', // *必填* 文本内容
                                            popTitle: '',
                                            popText: '',
                                            popIndex: 18,
                                            popWord: true,
                                            isPlay: false,
                                            word_url: require('@/assets/audio/2-1/19 amid.mp3'), // 单词音频,
                                            popWordTitle: [{
                                                    key: 'section3.1.1.1.4.1.4.1',
                                                    text: 'amid',
                                                    textStyle: {
                                                        fontFamily: 'Arial',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                    }
                                                },
                                                {
                                                    key: 'section3.1.1.1.2.1.4.2',
                                                    text: '/əˈmɪd/',
                                                    textStyle: {
                                                        fontFamily: 'Calibri',
                                                        color: '#999999',
                                                    }
                                                }
                                            ],
                                            popWordList: [{
                                                key: 'section3.1.1.1.11.1.4.3.1',
                                                text: '释义',
                                                textStyle: {
                                                    fontFamily: 'STXihei',
                                                    color: '#333',
                                                },
                                                content: [{
                                                    key: 'section3.1.1.1.11.1.4.3.1.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1211.3.1.2.4.4.1.113',
                                                            text: 'prep.  ',
                                                            textStyle: {
                                                                fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1211.3.1.2.4.4.1.1131',
                                                            text: '在',
                                                            textStyle: {

                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1211.3.1.2.4.4.1.1132',
                                                            text: '……',
                                                            textStyle: {
                                                                fontFamily: '宋体'
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1211.3.1.2.4.4.1.1133',
                                                            text: '中间；在',
                                                            textStyle: {

                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1211.3.1.2.4.4.1.1134',
                                                            text: '……',
                                                            textStyle: {
                                                                fontFamily: '宋体'
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1211.3.1.2.4.4.1.1135',
                                                            text: '之中',
                                                            textStyle: {

                                                            },
                                                        }
                                                    ]
                                                }, ]
                                            }],
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },
                                        }, {
                                            key: 'section3.1.1.1.11.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' the chaos and challenges, there is always hope for a better tomorrow.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                            },

                                        },

                                    ],
                                    textStyle: { // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        textIndent: 50, // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },

                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 0,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,

                                }
                            },
                            {
                                key: 'section3.1.1.1.12',
                                type: "wordAudio",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "New Words", // *必填* 标题文本内容
                                isexpand: false, //是否展开
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    marginTop: 20
                                        // fontFamily: 'Arial', // 字体，本地配置的字体
                                        // fontSize: 26, // 文字大小  默认：26
                                        // height:68,
                                        // width:'auto',
                                        // lineHeight: 68, // 行高  默认：46
                                        // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                        // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        // color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                },
                                content: [{
                                        key: 'section3.1.1.1.12.1', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/01 reunion.mp3'), // 单词音频
                                        content: [{
                                            key: 'section3.1.1.1.12.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'reunion', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˌriːˈjuːniən/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '重逢；团聚；聚会',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        key: 'section3.1.1.1.12.2', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/02 symbolize.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section1.6.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'symbolize', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈsɪmbəlaɪz/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '象征；是',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '……',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: '宋体', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '的象征；代表',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.3', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/03 anticipation.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.1.1.1.12.4', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'anticipation', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ænˌtɪsɪˈpeɪʃn/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '期盼；期望；预料',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.5', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/04 anticipate.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'anticipate', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ænˈtɪsɪpeɪt/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '预见；预计（并做准备）；预料；预期',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.6', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/05 hassle.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'hassle', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈhæsl/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '困难；麻烦',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.7', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/06 arduous.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.16.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'arduous', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈɑːdʒuəs/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'adj. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '艰苦的；艰难的',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.8', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/07 barely.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.46.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'barely', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈbeəli/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'adv. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '仅仅；勉强可能',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.9', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/08 verge.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.69.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'verge', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/vɜːdʒ/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '边；边缘；边沿',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.10', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/09 chord.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.610.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'chord', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/kɔːd/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '和弦；和音',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.12', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/10 aroma.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.612.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'aroma', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/əˈrəʊmə/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '（食物等的）香味；芳香',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.13', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/11 sparkle.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.613.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'sparkle', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈspɑːkl/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '闪烁；闪耀',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.14', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/12 weariness.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section1.6.2.2.14', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'weariness', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈwɪərinəs/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '疲倦；疲劳；厌倦',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.15', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/13 melt.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.615.2.2.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'melt', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/melt/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '熔化；融化',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.16', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/14 hearelt.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.616.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'heartfelt', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈhɑːtfelt/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'adj. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '真诚的；衷心的',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.17', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/15 festive.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.617.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'festive', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈfestɪv/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'adj. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '节日的；喜庆的；欢乐的',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.18', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/16 adorn.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.618.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'adorn', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/əˈdɔːn/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '装饰；装扮',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.19', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/17 reunite.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.619.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'reunite', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˌriːjuˈnaɪt/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'v. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '（使）团聚；（使）团圆',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.20', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/18 optimism.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.620.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'optimism', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/ˈɒptɪmɪzəm/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'n. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '乐观；乐观主义',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.21', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/19 amid.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.621.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'amid', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '/əˈmɪd/', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                                text: 'prep. ',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                                    fontSize: 28,
                                                    fontItalic: 1,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '在',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '……',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: '宋体', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '中间；在',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '……',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: '宋体', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            },
                                            {
                                                text: '之中',
                                                textStyle: {
                                                    color: '#999999',
                                                    fontFamily: 'STXihei', // 字体，本地配置的字体
                                                    fontSize: 22,
                                                    lineHeight: 36
                                                }
                                            }
                                        ],

                                    },
                                ]
                            },
                            {
                                key: 'section3.1.1.1.13',
                                type: "wordAudio",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "Expressions", // *必填* 标题文本内容
                                isexpand: false, //是否展开
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    marginTop: 20
                                        // fontFamily: 'Arial', // 字体，本地配置的字体
                                        // fontSize: 26, // 文字大小  默认：26
                                        // height:68,
                                        // width:'auto',
                                        // lineHeight: 68, // 行高  默认：46
                                        // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                        // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        // color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                },
                                content: [{
                                        key: 'section3.1.1.1.13.1', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/20 as usual.mp3'), // 单词音频
                                        content: [{
                                            key: 'section3.1.1.1.13.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'as usual', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '按惯例；一如既往',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }]
                                    },
                                    {
                                        key: 'section3.1.1.1.14.2', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/21 can’t help but do sth.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.16.3.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'can’t help but do sth.', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '忍不住做某事',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.12.4', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/22 on the verge of.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.1.1.1.12.4.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'on the verge of', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '濒于；接近于；行将',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.5', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/23 check on sb. sth.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.614.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'check on sb./sth.', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '核实 / 检查某人 / 某事（是否一切正常）',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.6', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/24 take one’s time.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.612.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'take one’s time', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '不急；慢慢来',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.7', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/25 strike a chord within with sb.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.16.2.2.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'strike a chord within/with sb.', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '引起某人的同情（或共鸣）',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.8', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/26 for the sake of.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.461.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'for the sake of', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '为了',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.9', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/27 sparkle with.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.691.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'sparkle with', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '闪烁着；闪耀着',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.10', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/28 melt away.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6101.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'melt away', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '慢慢消失',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.12', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/29 quality time.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6122.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'quality time', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '（尤指关爱子女，增进感情的）黄金时光',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.13', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/30 adorn sth. sb. with sth.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6131.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'adorn sth./sb. with sth.', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '用',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        },{
                                            text: '……',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: '宋体', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        },{
                                            text: '装饰某物 / 某人',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.142.14', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/31 catch up on.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.63e.2.2.14', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'catch up on', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '了解（已发生的事情）',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },
                                    {
                                        key: 'section3.1.1.1.14.15', // *必填* 唯一标识
                                        type: "", // *必填*
                                        // word_title: 'aristocrat', // 单词
                                        isPlay: false, //是否播放
                                        word_url: require('@/assets/audio/2-1/32 lie ahead.mp3'), // 单词音频
                                        // word_title_style: {
                                        //   color:'#333333',
                                        //   fontFamily: 'Calibri', // 字体，本地配置的字体
                                        //   fontSize: 32, // 文字大小  默认：26
                                        //   width:'auto',
                                        //   fontWeight:'bold',
                                        //   lineHeight:36
                                        //  },
                                        content: [{
                                            key: 'section3.6151.2.2.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'lie ahead', // *必填* 文本内容
                                            popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
                                            popText: '', // 气泡的内容
                                            popLink: '', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                                            textStyle: {
                                                color: '#333333',
                                                fontFamily: 'Calibri', // 字体，本地配置的字体
                                                fontSize: 32, // 文字大小  默认：26
                                                width: 'auto',
                                                fontWeight: 'bold',
                                                lineHeight: 36
                                            },
                                        }, ],
                                        word_mark: '', // 音标
                                        word_mark_style: {
                                            color: '#999999',
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            width: 'auto',
                                            lineHeight: 36
                                        },
                                        word_translate: [{
                                            text: '即将发生；即将来临',
                                            textStyle: {
                                                color: '#999999',
                                                fontFamily: 'STXihei', // 字体，本地配置的字体
                                                fontSize: 22,
                                                lineHeight: 36
                                            }
                                        }],

                                    },


                                ]
                            },

                        ]
                    },
                    {
                        key: 'section3.1.1.2',
                        type: 'tab2',
                        text: 'Learning More',
                        width: 198,
                        content: [{
                                key: 'section3.1.1.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.1.2.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: "Chinese New Year's Eve", // *必填* 文本内容
                                        textStyle: {

                                        },
                                    },
                                ],
                                textStyle: {
                                    fontFamily: 'Calibri', // 字体，本地配置的字体
                                    fontSize: 24, // 文字大小  默认：20
                                    // lineHeight: 40, // 行高  默认：36
                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },

                            },

                            // 视频
                            {
                                key: 'section3.1.1.2.2', // *必填* 唯一标识
                                type: 'video', // *必填* 类型：视频
                                templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
                                playerInline: 1, // 是否是行内播放 1：行内播放
                                styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
                                content: [ // *必填* 视频列表
                                    {
                                        key: 'section3.1.1.2.2.1', // *必填* 唯一标识
                                        url: require("@/assets/video/book2/3-1-3 Chinese New Year's Eve.mp4"), // *必填* 视频地址
                                        left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                                        title: '2-5 如何过春节', // 视频标题
                                        subtitle: '2-5 如何过春节', // 视频副标题 只在全部显示时使用
                                        titleStyle: {
                                            height:372
                                            // 根据需要是否加标题样式
                                            // fontFamily: 'xxx', // 字体，本地配置的字体
                                            // fontSize: 20, // 文字大小  默认：20
                                            // lineHeight: 40, // 行高  默认：36
                                            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                                            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            // color: '#333', // 文本颜色  默认：#00a8ac
                                            // backgroundColor: '#FFF', // 背景颜色  默认：无
                                            // padding: 20,
                                            // margin: 20
                                        }
                                    },
                                ],
                            },
                        ]
                    },
                ],
            },
            {
                key: 'section3.1.2',
                type: 'tab1',
                text: 'Language in Use',
                content: [{
                        key: 'section3.1.2.1',
                        type: 'tab2',
                        text: 'Vocabulary',
                        width: 160,
                        borderBottom: 1,
                        content: [{
                            key: 'section3.1.2.1.1', // *必填* 唯一标识
                            type: 'switchAudio', // *必填* 类型：正文
                            isInTable: true,
                            content: [
                                {
                                    key: 'section3.1.2.1.1.1', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/02 symbolize.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.1.0',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.2',
                                            text: 'symbolize',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.2.3',
                                            text: '/ˈsɪmbəlaɪz/',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.2.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.2.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.2.4.1.1',
                                                        text: 'v. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.2',
                                                        text: 'to represent something  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.3',
                                                        text: '象征；是',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.3',
                                                        text: '……',
                                                        textStyle: {
                                                            fontFamily: '宋体',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.3',
                                                        text: '的象征；代表',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.2.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.2.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.2.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.2.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.2',
                                                            text: 'The red color symbolizes danger in many countries.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.3',
                                                            text: '红色在许多国家代表危险。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.4',
                                                            text: 'Eating the cakes under the moon symbolizes our longing for distant relatives and friends.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.5',
                                                            text: '月下品尝月饼寄托着我们对远方亲友的思念。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.2', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/02 anticipate.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.2.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.2.2',
                                            text: 'anticipate',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.2.3',
                                            text: '/ænˈtɪsɪpeɪt/',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.2.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.2.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.2.4.1.1',
                                                        text: 'v. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.2',
                                                        text: 'to imagine or expect that something will happen; to take action in preparation for something that you think will happen  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.2.4.1.3',
                                                        text: '预见；预计（并做准备）；预料；预期',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.2.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.2.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.2.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.2.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.2',
                                                            text: 'He tried to anticipate all my needs.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.3',
                                                            text: '他设法将我需要的东西预先准备好。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.4',
                                                            text: 'I anticipate deriving much instruction from the lecture.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.2.5.2.5',
                                                            text: '我期望从这演讲中获得很多教益。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.3', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/03 melt.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.3.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.3.1.1',
                                            text: 'melt',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.3.1.2',
                                            text: '/melt/',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.3.1.3',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.3.1.4',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.3.1.4.1',
                                                        text: 'v. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.3.1.4.2',
                                                        text: 'to turn from something solid into something soft or liquid, or to cause something to do this  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.3.1.4.3',
                                                        text: '熔化；融化',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.3.1.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.3.1.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.3.1.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.3.1.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.3.1.5.2.2',
                                                            text: 'These chocolates really melt in your mouth.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.3.1.5.2.3.1',
                                                            text: '这些巧克力真的是入口即化。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.3.1.5.2.41',
                                                            text: 'The sun melted the snow.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.3.1.5.2.5',
                                                            text: '太阳使雪融化。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.4', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/04 festive.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.4.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.4.2',
                                            text: 'festive',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.4.3',
                                            text: '/ˈfestɪv/',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.4.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.4.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.4.4.1.12',
                                                        text: 'adj. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.4.4.1.123',
                                                        text: 'having or producing happy and enjoyable feelings suitable for a festival or other special occasion  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.4.4.1.23',
                                                        text: '节日的；喜庆的；欢乐的',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.4.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.4.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.4.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.4.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.2',
                                                            text: 'Christmas is often called the festive season.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.3',
                                                            text: '圣诞节常被称作欢乐的时节。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.4',
                                                            text: 'The atmosphere is really festive and friendly.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.5',
                                                            text: '气氛真是欢乐而友好。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.6',
                                                            text: 'In Chinese culture, red is the festive color.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.4.5.2.7',
                                                            text: '在中国文化中，红色是喜庆的颜色。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.5', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/05 optimism.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.5.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.5.2',
                                            text: 'optimism',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.5.3',
                                            text: '/ˈɒptɪmɪzəm/',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.5.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.5.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.5.4.1.1',
                                                        text: 'n. ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.5.4.1.2',
                                                        text: 'the quality of being full of hope and emphasizing the good parts of a situation, or a belief that something good will happen  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.5.4.1.3',
                                                        text: '乐观；乐观主义',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.5.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.5.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.5.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.5.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.5.5.2.2',
                                                            text: 'He is a man of apparently boundless optimism.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.5.5.2.3',
                                                            text: '他显然是一个极度乐观的人。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.5.5.2.4',
                                                            text: 'Optimism made him alive through the hard days.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.5.5.2.5',
                                                            text: '乐观主义使他在艰难的岁月里活了下来。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.7', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/06 can’t help but do sth.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.7.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.7.2',
                                            text: 'can’t help but do sth.',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.7.3',
                                            text: '',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.7.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.7.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.7.4.1.1',
                                                        text: 'unable to choose any but one course of action  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.7.4.1.21',
                                                        text: ' 忍不住做某事',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.7.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.7.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.7.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.7.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.5.2.2',
                                                            text: 'I can’t help feeling sorry for the poor man.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.5.2.3',
                                                            text: '我不禁为这个可怜的男人感到难过。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            key: 'section3.1.2.1.1.7.6',
                                            text: '词以类记',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 14
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.7.6.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.7.6.1.1',
                                                            text: '（1）can’t help do sth： ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.1.2',
                                                            text: '无法帮助做某事',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.7.6.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.7.6.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.2.2',
                                                            text: 'I can’t help to clean the room.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.2.3',
                                                            text: '我无法帮助打扫房间。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.7.6.3',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.7.6.3.1',
                                                            text: '（2）can’t help but do： ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.3.2',
                                                            text: '只能做某事，不得不做；不能不；必须；只好',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.7.6.4',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.7.6.4.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.4.2',
                                                            text: 'I can’t help but smile when I think of you.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.7.6.4.3',
                                                            text: '我一想到你就忍不住笑。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.8', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/07 check on sb. sth.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.8.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.8.2',
                                            text: 'check on sb./sth.',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.8.3',
                                            text: '',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.8.4',
                                            text: '释义',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                key: 'section3.1.2.1.1.8.4.1',
                                                text: '',
                                                // textFlex:true,
                                                textStyle: {},
                                                content: [{
                                                        key: 'section3.1.2.1.1.8.4.1.1',
                                                        text: 'to look at someone or something in order to make sure that they are safe, correct, etc  ',
                                                        textStyle: {
                                                            fontFamily: 'Calibri',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44,
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.2.1.1.8.4.1.2',
                                                        text: '核实/ 检查某人/ 某事（是否一切正常）',
                                                        textStyle: {
                                                            fontFamily: 'STXihei',
                                                            color: '#333',
                                                            fontSize: device.isMobile ? 28 : 24,
                                                            lineHeight: 44
                                                        },
                                                    },
                                                ]
                                            }, ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.8.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.8.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.8.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.8.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.8.5.2.2',
                                                            text: 'You will need to check on your new employees’ qualifications.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.8.5.2.3',
                                                            text: '你需要核实新员工的资质。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },

                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },
                                {
                                    key: 'section3.1.2.1.1.9', // *必填* 唯一标识
                                    category: '', // *必填*
                                    textStyle: {},
                                    isPlay: false,
                                    word_url: require('@/assets/audio/2-1/08 for the sake of.mp3'), // 单词音频,
                                    soundContent: {
                                        key: 'section3.1.2.1.1.9.1',
                                        type: "sound",
                                        category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                        text: "", // *必填* 标题文本内容
                                        titleImageType: 3,
                                        // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                        textStyle: {
                                            fontFamily: 'Arial', // 字体，本地配置的字体
                                            fontSize: 26, // 文字大小  默认：26
                                            height: 49,
                                            width: 'auto',
                                            lineHeight: 49, // 行高  默认：46
                                            maxWidth: 500,
                                            // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                            color: '#fff', // 文本颜色  默认：#00a8ac
                                            backgroundColor: '#5CA683', // 背景颜色  默认：无
                                            // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                            borderRadius: {
                                                borderTopLeftRadius: 20,
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 20,
                                                borderBottomLeftRadius: 0
                                            }
                                        },
                                    },
                                    popWordTitle: [{
                                            key: 'section3.1.2.1.1.9.2',
                                            text: 'for the sake of',
                                            textStyle: {
                                                fontFamily: 'Arial',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: 18,
                                            }
                                        },
                                        {
                                            key: 'section3.1.2.1.1.9.3',
                                            text: '',
                                            textStyle: {
                                                fontFamily: 'Calibri',
                                                color: '#999999',
                                                fontSize: 14,
                                            }
                                        }
                                    ],
                                    popWordList: [{
                                            key: 'section3.1.2.1.1.9.4',
                                            text: '用法',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.9.4.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.9.4.1.1',
                                                            text: 'in order to help or bring advantage to someone; because of, or for the purpose of something  ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.4.1.2',
                                                            text: '为了  ',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.9.4.2',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.9.4.2.1',
                                                            text: 'for the sake of someone/something = for someone’s/something’s sake',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                            },
                                                        },

                                                    ]
                                                },
                                            ]
                                        },

                                        {
                                            key: 'section3.1.2.1.1.9.5',
                                            text: '例句',
                                            textStyle: {
                                                fontFamily: 'STXihei',
                                                color: '#333',
                                                fontSize: 28
                                            },
                                            content: [{
                                                    key: 'section3.1.2.1.1.9.5.1',
                                                    text: '',
                                                    // textFlex:true,
                                                    textStyle: {},
                                                    content: []
                                                },
                                                {
                                                    key: 'section3.1.2.1.1.9.5.2',
                                                    text: '',
                                                    textFlex: true,
                                                    textStyle: {},
                                                    content: [{
                                                            key: 'section3.1.2.1.1.9.5.2.1',
                                                            text: 'e.g. ',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44,
                                                                fontItalic: 1,
                                                            },

                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.2',
                                                            text: 'Their parents only stayed together for the sake of the children.',
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.3',
                                                            text: '他们的父母仅仅是为了孩子才没有分开。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.4',
                                                            text: "I hope for both our sakes that you're right!",
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.5',
                                                            text: '为你我着想，我希望你是对的！',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.6',
                                                            text: "Let’s not disagree for the sake of (= because of) a few dollars.",
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.7',
                                                            text: '咱们不要因为几块钱闹别扭。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.8',
                                                            text: "You’re only arguing for the sake of arguing (= because you like arguing).",
                                                            textStyle: {
                                                                fontFamily: 'Calibri',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                        {
                                                            key: 'section3.1.2.1.1.9.5.2.8',
                                                            text: '你只是为争论而争论。',
                                                            textStyle: {
                                                                fontFamily: 'STXihei',
                                                                color: '#333',
                                                                fontSize: device.isMobile ? 28 : 24,
                                                                lineHeight: 44
                                                            },
                                                        },
                                                    ]
                                                }
                                            ]
                                        },

                                    ],
                                },

                            ],
                            // content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                            //     {
                            //         key: 'section1.14.1.1.1.1', // *必填* 唯一标识
                            //         category: 'text', // *必填* 内容类型 text：文本
                            //         text: '某大学毕业生张强的职业目标是成为一名优秀的机械工程技术人员，他最近参加了一家机械设计公司的面试，面试官为了检验他对国家标准的掌握情况，让他指出图样（见图', // *必填* 文本内容
                            //         textStyle: {},
                            //     },
                            //     {
                            //         key: 'section1.14.1.1.1.2', // *必填* 唯一标识
                            //         category: 'text', // *必填* 内容类型 text：文本
                            //         text: '666', // *必填* 文本内容
                            //         textStyle: {
                            //             fontFamily: 'Times New Roman', // 字体，本地配置的字体
                            //         },
                            //     },
                            //     {
                            //         key: 'section1.14.1.1.1.3', // *必填* 唯一标识
                            //         category: 'text', // *必填* 内容类型 text：文本
                            //         text: '）中的错误。请帮他指出该图样中的错误，并改正这些错误。', // *必填* 文本内容
                            //         textStyle: {},
                            //     },
                            // ],
                            textStyle: {
                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                // fontSize: 20, // 文字大小  默认：20
                                // lineHeight: 40, // 行高  默认：36
                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                color: '#333', // 文本颜色  默认：#00a8ac
                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                            },
                        }, ]
                    },
                    {
                        key: 'section3.1.2.2',
                        type: 'tab2',
                        text: 'Grammar',
                        width: 140,
                        borderBottom: 1,
                        content: [{
                                key: 'section3.1.2.2.1',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '1.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section1.12.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section1.12.6.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'The thought of dealing with crowded roads and the chaos of preparations made me question whether it was worth all the hassle.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            {
                                key: 'section3.1.2.2.2',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.12.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.12.6.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'The thought of dealing with crowded roads and the chaos of preparations', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.2', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '为主语，', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'me', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.4', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '为宾语，“', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'question whether it was worth all the hassle', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.6', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”为宾语补足语。其中 “', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.7', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'whether it was worth all the hassle', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”是由', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.9', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' whether ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.10', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '引导的', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.11', // *必填* 唯一标识
                                            category: 'video', // *必填* 内容类型 text：文本
                                            text: '宾语从句', // *必填* 文本内容
                                            url: require("@/assets/video/book2/3-2-2-1 宾语从句.mp4"), // *必填* 视频地址
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.12', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '做', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.13', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' question ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.14', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '的宾语。', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#fff', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#fff",
                                }
                            },
                            {
                                key: 'section3.1.2.2.3',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '2.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section1.12.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section1.12.6.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'I realized that no matter how inconvenient or tiring the journey may be, it was all for the sake of being with my loved ones during this special time.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            {
                                key: 'section3.1.2.2.4',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.2.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.2.6.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '“', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.6.1.2', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'that no matter how… during this special time', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.6.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”为宾语从句。其中“', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.13', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'no matter how inconvenient or tiring the journey may be', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.14', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”为', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.15', // *必填* 唯一标识
                                            category: 'video', // *必填* 内容类型 text：文本
                                            text: '让步状语从句', // *必填* 文本内容
                                            url: require("@/assets/video/book2/3-2-2-2 让步状语从句.mp4"), // *必填* 视频地址
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.16', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '，“', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.17', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'it was all for the sake of being with my loved ones during this special time', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.18', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”为主句。', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.19', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'it ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.20', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '指代前文提到的', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.21', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' the journey', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.12.6.1.22', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '。', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#fff', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#fff",
                                }
                            },
                            {
                                key: 'section3.1.2.2.51',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '3.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.2.2.51.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'ssection3.1.2.2.51.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'As the days passed, I realized that the Spring Festival was not just a celebration of the past year but a hopeful anticipation of what lies ahead.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            {
                                key: 'section3.1.2.2.61',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.2.2.61.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.2.2.61.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '“that the Spring Festival was not just a celebration… what lies ahead”', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.2', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '是由', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.3', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' that ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.4', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '引导的宾语从句，做', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.5', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' realize ', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.6', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '的宾语。', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.7', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'not just… but…', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: ' 是一个连词词组，连接两个并列的成分，意为“不仅', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '……', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: '宋体', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '而且', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '……', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: '宋体', // 字体，本地配置的字体

                                            },
                                        },
                                        {
                                            key: 'section3.1.2.2.61.1.8', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: '”。', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#fff', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#fff",
                                }
                            },
                            {
                                key: 'section3.1.2.2.6',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '4.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.2.2.6.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.2.2.6.1.1', // *必填* 唯一标识
                                            category: 'video', // *必填* 内容类型 text：文本
                                            text: '词根词缀', // *必填* 文本内容
                                            url: require("@/assets/video/book2/3-2-2-3 词根词缀.mp4"), // *必填* 视频地址
                                            textStyle: {
                                                fontFamily: 'STXihei', // 字体，本地配置的字体

                                            },
                                        },
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            // 图片
                            {
                                key: 'section3.6.10', // *必填* 唯一标识
                                type: 'image', // *必填* 类型：正文
                                // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
                                // cover: require("@/assets/images/bookContent/single_video.png"),
                                content: [ // *必填* 图片列表
                                    {
                                        key: 'section2.3.4.1', // *必填* 唯一标识
                                        url: require("@/assets/images/books/book2/004.png"), // *必填* 图片地址
                                        //title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-7<\/i>  图线画法示例", // 图片标题
                                        //titlePosition: 'top', // 标题位置， 默认为bottom
                                        titleStyle: {

                                        }
                                    }
                                ],
                            },

                        ]
                    },
                    {
                        key: 'section3.1.2.3',
                        type: 'tab2',
                        text: 'Words in Use',
                        width: 192,
                        borderBottom: 1,
                        content: [
                            // 交互 连连看
                            {
                                key: 'section3.1.2.3.1', // *必填* 唯一标识
                                type: 'action', // *必填* 类型：交互
                                actionType: 1, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                                styleType: 3, // 样式类型 actionType = 2 时 1：默认示例中样式 2：英语中样式，拖拽字母 3：英语中，文字拖拽样式
                                title: 'Complete the following sentences with the words given below.', // 标题
                                titleStyle: {},
                                // isBlock: 1, // 是否默认存在一个区域框
                                content: {
                                    // 连连看
                                    key: 'action3',
                                    leftData: [{
                                            key: 'action3.1.1',
                                            actionKey: 'action3',
                                            answerKey: 'key1',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '1. ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' greetings and warm wishes are exchanged during the special traditional holidays.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.2',
                                            actionKey: 'action3',
                                            answerKey: 'key2',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '2. The young man seemed pleased at the suggestion, and his dark eyes ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' with pleasure.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.3',
                                            actionKey: 'action3',
                                            answerKey: 'key3',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '3. The wonderful Spring Festival Gala was rounded off ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' joy and happiness.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.4',
                                            actionKey: 'action3',
                                            answerKey: 'key4',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '4. Since Jiaozi is in the shape of ancient Chinese gold or silver ingots (元宝), it ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' wealth.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.5',
                                            actionKey: 'action3',
                                            answerKey: 'key5',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '5. The entire family was filled with ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' and excitement about the upcoming New Year.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.6',
                                            actionKey: 'action3',
                                            answerKey: 'key6',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '6. His usually forceful voice was lowered to a(n) ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' audible (听得见的) whisper.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.7',
                                            actionKey: 'action3',
                                            answerKey: 'key7',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '7. ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: ' didn’t dampen his enthusiasm for going home for the holidays.'
                                                }
                                            ]
                                        },
                                        {
                                            key: 'action3.1.8',
                                            actionKey: 'action3',
                                            answerKey: 'key8',
                                            answerContent: [{
                                                    type: 'text',
                                                    text: '8. People cherish some festivals because they are the days for family ',
                                                },
                                                {
                                                    type: 'input',
                                                },
                                                {
                                                    type: 'text',
                                                    text: '.'
                                                }
                                            ]
                                        }
                                    ],
                                    rightData: [{
                                            key: 'action3.2.1',
                                            actionKey: 'action3',
                                            actionLabel: 'sparkled',
                                            answerKey: 'key2'
                                        },
                                        {
                                            key: 'action3.2.2',
                                            actionKey: 'action3',
                                            actionLabel: 'Weariness',
                                            answerKey: 'key7'
                                        },
                                        {
                                            key: 'action3.2.3',
                                            actionKey: 'action3',
                                            actionLabel: 'Heartfelt',
                                            answerKey: 'key1'
                                        },
                                        {
                                            key: 'action3.2.4',
                                            actionKey: 'action3',
                                            actionLabel: 'barely',
                                            answerKey: 'key6'
                                        },
                                        {
                                            key: 'action3.2.5',
                                            actionKey: 'action3',
                                            actionLabel: 'anticipation',
                                            answerKey: 'key5'
                                        },
                                        {
                                            key: 'action3.2.6',
                                            actionKey: 'action3',
                                            actionLabel: 'reunions',
                                            answerKey: 'key8'
                                        },
                                        {
                                            key: 'action3.2.7',
                                            actionKey: 'action3',
                                            actionLabel: 'amid',
                                            answerKey: 'key3'
                                        },
                                        {
                                            key: 'action3.2.8',
                                            actionKey: 'action3',
                                            actionLabel: 'symbolizes',
                                            answerKey: 'key4'
                                        }
                                    ],

                                },
                            },
                        ]
                    },
                    {
                        key: 'section3.1.2.4',
                        type: 'tab2',
                        text: 'Translation',
                        width: 160,
                        borderRight: 0,
                        borderBottom: 1,
                        content: [{
                                key: 'section3.1.2.4.1',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 15,
                                        marginLeft: 0,
                                        marginRight: 14,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },
                                    popContent: { // 气泡
                                        key: 'section3.91.2.1', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        // text: '轴线', // *必填* 文本内容
                                        textSlot: 1, // 是否以插槽方式引入内容
                                        // popTitle: '轴线的名词解释',
                                        popText: '',
                                        content: [{
                                                key: 'section3.91.2.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section1.9.2.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '参考答案', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                                            fontSize: '24px',
                                                            fontWeight: 'bold'
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.1.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.1.2.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '1. the Spring Festival symbolizes family reunion, happiness, and anticipation', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.1.3', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.1.3.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '2. question whether it was worth all the hassle', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.1.4', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section1.9.2.1.4.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '3. the Spring Festival was not just a celebration of the past year but a hopeful anticipation of what lies ahead', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.1.5', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.1.5.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '3. amid the chaos and challenges, there is always hope for a better tomorrow', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },

                                        ],
                                        textStyle: {

                                        },
                                    },
                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.91.12.2', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    isRefresh:true,//是否显示刷新按钮
                                    answerType:2,//1:寒食节列表  2.简答题
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.91.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Read the following talk show and translate the Chinese sentences into English.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Arial', // 字体，本地配置的字体
                                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            },
                                        }
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 38, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 50,
                                    padding: 0,
                                    // paddingLeft: 20,
                                    // paddingRight: 20,
                                }
                            },
                            // 图片
                            // {
                            //     key: 'section3.1.2.4.2', // *必填* 唯一标识
                            //     type: 'image', // *必填* 类型：正文
                            //     // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
                            //     // cover: require("@/assets/images/bookContent/single_video.png"),
                            //     content: [ // *必填* 图片列表
                            //         {
                            //             key: 'section3.1.2.4.2.1', // *必填* 唯一标识
                            //             url: require("@/assets/images/books/book2/Aletterfrem.png"), // *必填* 图片地
                            //             heightNoLimit: 1,
                            //             //titlePosition: 'top', // 标题位置， 默认为bottom
                            //             titleStyle: {

                            //             }
                            //         }
                            //     ],
                            // },
                            {
                                key: 'section3.1.2.4.2.1',
                                type: "title",
                                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "A Letter from Betsy",
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 28, // 文字大小  默认：26
                                    lineHeight: 36, // 行高  默认：46
                                    textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
                                    marginTop: 10,
                                },
                            },
                            {
                                key: 'section3.1.2.4.2.2', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.2.4.2.2.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'Welcome to Faith Radio Online—Simply to Relax, I’m Faith. Immediately after the Chinese New Year holiday in February this year, we received letters from many audiences.', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    }
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                    lineHeight: 40, // 行高  默认：36
                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section3.1.2.4.2.3', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.2.4.2.3.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'The letter in my hand comes from an audience named Betsy from Guangzhou. She wrote that ', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.3.2', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '____________', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.3.3', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: ' ( 春节象征着家庭团聚、幸福和期待 ) for many people, but it seemed like a burden to her at times. She was upset about long time driving and heavy traffic which made her ', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.3.4', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '____________', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.3.5', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: ' ( 怀疑是否值得这么麻烦 ), but later she changed her mind.', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                    lineHeight: 40, // 行高  默认：36
                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section3.1.2.4.2.4', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.2.4.2.4.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'When she returned home, she saw her parents staying up late to welcome her regardless of their old age. During the Spring Festival, she spent a wonderful time with her parents and had a joyful gathering with her old friends, which made her realize that ', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.4.2', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '____________', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.4.3', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: ' ( 春节不仅是对过去一年的庆祝，也是对未来充满希望的期待 ). Betsy said that the Spring Festival means new beginnings and it has taught her that ', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.4.4', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: '____________', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                    {
                                        key: 'section3.1.2.4.2.4.5', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: ' ( 在混乱和挑战中，总有希望拥有更美好的明天 ).', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                    lineHeight: 40, // 行高  默认：36
                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section3.1.2.4.2.5', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.2.4.2.5.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'Returning home for the Spring Festival holds immense significance for us. It is a moment that brings joy, warmth, and a sense of belonging that cannot be replicated.', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    }
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                    lineHeight: 40, // 行高  默认：36
                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                },
                            },
                            {
                                key: 'section3.1.2.4.2.6', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section3.1.2.4.2.6.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'Well, dear listeners, this is the end of today’s programme. And thanks everyone for listening and we look forward to seeing you next time. Bye!', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    }
                                ],
                                textStyle: {
                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                    fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                                    lineHeight: 40, // 行高  默认：36
                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#333', // 文本颜色  默认：#00a8ac
                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    marginBottom: 30,
                                },
                            },
                            // 答题
                            {
                                key: 'section3.1.2.4.3', // *必填* 唯一标识
                                type: 'question', // *必填* 类型：答题
                                onlyContent: 1, // 只存在内容
                                noPadding: 1, // 左右没有边距
                                refreshSection:"section3.91.12.2",
                                submitBtnStyle: { //按钮的样式
                                    width: 180,
                                    height: 52,
                                    lineHeight: 52, // 行高  默认：46
                                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                                },
                                content: [{
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">1 <\/span><span>She wrote that ____________( <span style=\"font-family: '宋体';\">春节象征着家庭团聚、幸福和期待<\/span> )for many people, but it seemed like a burden to her at times. <\/span><\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                    {
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">2 <\/span><span>She was upset about long time driving and heavy traffic which made her ____________  ( <span style=\"font-family: '宋体';\">怀疑是否值得这么麻烦<\/span> ), but later she changed her mind.<\/span><\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                    {
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">3 <\/span><span> During the Spring Festival, she spent a wonderful time with her parents and had a joyful gathering with her old friends, which made her realize that ____________  ( <span style=\"font-family: '宋体';\">春节不仅是对过去一年的庆祝，也是对未来充满希望的期待<\/span> ). <\/span><\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                    {
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">4 <\/span><span>Betsy said that the Spring Festival means new beginnings and it has taught her that ____________ ( <span style=\"font-family: '宋体';\">在混乱和挑战中，总有希望拥有更美好的明天<\/span> ).<\/span><\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                ],
                                completeType: '', // 答题完成后的操作 statistics：展示统计结果
                            },

                        ]
                    },
                    {
                        key: 'section3.1.2.5',
                        type: 'tab2',
                        text: 'Writing',
                        width: 120,
                        content: [{
                                key: 'section3.1.2.5.1',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 15,
                                        marginLeft: 0,
                                        marginRight: 14,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },
                                    popContent: { // 气泡
                                        key: 'section3.91.2.5.1', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        // text: '轴线', // *必填* 文本内容
                                        textSlot: 1, // 是否以插槽方式引入内容
                                        // popTitle: '轴线的名词解释',
                                        popText: '',
                                        content: [{
                                                key: 'section3.91.2.5.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.5.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '参考答案', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                                            fontSize: '24px',
                                                            fontWeight: 'bold'
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.5.1.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.5.1.2.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '1. Their words touched the very core of my heart.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.5.1.3', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.5.1.3.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '2. I smelt the aroma of the meal cooked by my mother when I walked through the front door.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.91.2.5.1.4', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.91.2.5.1.4.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '3. On the contrary, I took the opportunity to spend a good time with my parents.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                        ],
                                        textStyle: {

                                        },
                                    },
                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.91.12.88', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    isRefresh:true,//是否显示刷新按钮
                                    answerType:2,//1:寒食节列表  2.简答题
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.91.2.2.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Rewrite the following sentences in your own words.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Arial', // 字体，本地配置的字体
                                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            },
                                        }
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 38, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 50,
                                    padding: 0,
                                    // paddingLeft: 20,
                                    // paddingRight: 20,
                                }
                            },
                            // 答题
                            {
                                key: 'section3.1.2.4.3', // *必填* 唯一标识
                                type: 'question', // *必填* 类型：答题
                                onlyContent: 1, // 只存在内容
                                noPadding: 1, // 左右没有边距
                                refreshSection:"section3.91.12.88",
                                submitBtnStyle: { //按钮的样式
                                    width: 180,
                                    height: 52,
                                    lineHeight: 52, // 行高  默认：46
                                    backgroundColor: '#F6A84C', // 背景颜色  默认：无
                                },
                                content: [{
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">1 <\/span>Their words struck a chord within me.<\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                    {
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">2 <\/span>As I stepped through the front door, I was greeted with the comforting aroma of my mother’s cooking.<\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },
                                    {
                                        "topic_id": 57,
                                        "id": 57,
                                        "type_id": 4,
                                        "typenm": "简答题",
                                        "shorttag": "",
                                        "showway": "",
                                        "topic_score": "8.00",
                                        "isauto": 0,
                                        "info": "",
                                        "km": "",
                                        "stem_url": "",
                                        "audiofile": "",
                                        "audiofile_suffix": "",
                                        "audiofile_title": "附件下载",
                                        "is_collect": 0,
                                        "status": 0,
                                        "is_play": 0,
                                        "issign": 0,
                                        "isok": 0,
                                        "isdone": 0,
                                        "getscore": 0,
                                        "comment": "",
                                        "ischeck": 0,
                                        "ps_info": "根据相关要求，完成下列题目。",
                                        "topic_sub": [{
                                            "shorttag": "",
                                            "direction": 0,
                                            "type_id": 4,
                                            "typenm": "简答题",
                                            "score": "8.00",
                                            "topic_id": 57,
                                            "sub_id": 1,
                                            "isauto": 0,
                                            "is_upload": 0,
                                            "para44_id": 0,
                                            "upload_explain": "",
                                            "options": [],
                                            "showway": "",
                                            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri; color: #5CA683; \"><span style=\"font-family:'Calibri'; display: flex;\"><span style=\"font-style: italic; margin-right: 16rem;\">3 <\/span> Instead, I embraced the opportunity to spend quality time with my parents.<\/span><\/p>",
                                            "subanalysis": "",
                                            "sortid": 1,
                                            "file_name": "",
                                            "user_answer": [],
                                            "brief_answer": {},
                                            "user_status": -1,
                                            "answer_img": {},
                                            "topic_answer": [{
                                                "topic_id": 57,
                                                "sub_id": 1,
                                                "sortid": 1,
                                                "ask": "",
                                                "answer": "",
                                                "askend": null,
                                                "answer_id": 1,
                                                "answer_url": "",
                                                "answertitle": null,
                                                "score": "8.00",
                                                "operation_score": 0
                                            }],
                                            "video_list": [],
                                            "isok": 0,
                                            "isdone": 0,
                                            "concat_answer": "",
                                            "user_concat_answer": ""
                                        }]
                                    },

                                ],
                                completeType: '', // 答题完成后的操作 statistics：展示统计结果
                            },
                        ]
                    },
                ]
            },
            {
                key: 'section3.1.3',
                type: 'tab1',
                text: 'Understanding',
                tab2Width: 558,
                content: [{
                        key: 'section3.1.3.1',
                        type: 'tab2',
                        text: 'Structure Analysis',
                        width: 246,
                        borderBottom: 1,
                        content: [
                            // 表格
                            {
                                key: 'section3.1.3.1.1', // *必填* 唯一标识
                                type: 'table', // *必填* 类型：表格
                                styleType: 2, // 表格样式 2：英语项目可输入 3：英语项目可输入左右表格
                                // 表格 的数据
                                content: [{
                                    key: 'section3.1.3.1.1.1', // *必填* 唯一标识
                                    //   tabText: '详解版',?
                                    tableHeader: [
                                        { label: "Parts", prop: "tableLabel1", width: 116 },
                                        { label: "Paragraphs", prop: "tableLabel2", width: 185 },
                                        { label: "Main Idea", prop: "tableLabel3" },
                                    ],
                                    tableData: [{
                                            tableLabel1: {
                                                key: 'section3.1.3.1.1.1.table1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.1.1.1.table1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'Part 1', // *必填* 文本内容
                                                        textStyle: {},
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },

                                            tableLabel2: {
                                                key: 'section3.1.3.1.1.1.table1.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    { // 气泡
                                                        key: 'section3.1.3.1.1.1.table1.2.1', // *必填* 唯一标识
                                                        category: 'popover', // *必填* 内容类型 text：文本
                                                        text: 'Para. 1', // *必填* 文本内容
                                                        inBody: 1,
                                                        // popTitle: '轴线的名词解释',
                                                        // popText: '',
                                                        content: [{
                                                            key: 'section3.1.3.1.1.1.table1.2.1.1', // *必填* 唯一标识
                                                            type: 'text', // *必填* 类型：正文
                                                            isInTable: true,
                                                            content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                {
                                                                    key: 'section3.1.3.1.1.1.table1.2.1.1.1', // *必填* 唯一标识
                                                                    category: 'text', // *必填* 内容类型 text：文本
                                                                    text: '1  What does the Spring Festival mean to you? For most people, the Spring Festival symbolizes family reunion, happiness, and anticipation. However, for me, it sometimes feels like a burden.', // *必填* 文本内容
                                                                    textStyle: {
                                                                        fontFamily: 'Calibri',
                                                                        fontSize: 26,
                                                                        lineHeight: 32, // 行高
                                                                    },
                                                                },
                                                            ],
                                                            textStyle: {
                                                                // fontFamily: 'xxx', // 字体，本地配置的字体
                                                                // fontSize: 20, // 文字大小  默认：20
                                                                // lineHeight: 40, // 行高  默认：36
                                                                // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                                // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                                // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                                // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                                color: '#111', // 文本颜色  默认：#00a8ac
                                                                // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                            },
                                                        }, ],
                                                        textStyle: {

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },
                                            tableLabel3: {
                                                key: 'section3.1.3.1.1.1.table1.3', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.1.1.1.table1.3.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'What the Spring Festival initially  meant to the author.', // *必填* 文本内容
                                                        textStyle: {},
                                                    },
                                                ],
                                                textStyle: {
                                                    textAlign: 'left',
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1
                                                },
                                            },
                                        },
                                        {
                                            tableLabel1: {
                                                key: 'section3.1.3.1.1.1.table2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.1.1.1.table2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'Part 2', // *必填* 文本内容
                                                        textStyle: {},
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },
                                            tableLabel2: {
                                                key: 'section3.1.3.1.1.1.table2.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    { // 气泡
                                                        key: 'section3.1.3.1.1.1.table2.2.1', // *必填* 唯一标识
                                                        category: 'popover', // *必填* 内容类型 text：文本
                                                        text: 'Para. 2-6', // *必填* 文本内容
                                                        inBody: 1,
                                                        // popTitle: '轴线的名词解释',
                                                        // popText: '',
                                                        content: [{
                                                                key: 'section3.1.3.1.1.1.table2.2.1.1', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table2.2.1.1.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '2  Last year, as usual, I embarked on my journey home for the Spring Festival. Despite the long drive and the anticipated traffic, I couldn’t help but feel a sense of dread. The thought of dealing with crowded roads and the chaos of preparations made me question whether it was worth all the hassle.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {
                                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                                    // fontSize: 20, // 文字大小  默认：20
                                                                    // lineHeight: 40, // 行高  默认：36
                                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                                    // color: '#111', // 文本颜色  默认：#00a8ac
                                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                                },
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table2.2.1.2', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table2.2.1.2.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '3  As expected, the journey was arduous. I found myself sitting in my car for hours, barely moving an inch. The frustration grew as time passed by. But just when I was on the verge of losing hope, my phone rang. It was my parents calling to check on me. Their voices were filled with warmth and love, reminding me to take my time and not to rush.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table2.2.1.3', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table2.2.1.3.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '4  Their words struck a chord within me. I realized that no matter how inconvenient or tiring the journey may be, it was all for the sake of being with my loved ones during this special time. Their constant support and understanding gave me a renewed sense of purpose.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table2.2.1.4', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table2.2.1.4.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '5  Finally, after what felt like an eternity, I arrived home. As I stepped through the front door, I was greeted with the comforting aroma of my mother’s cooking. The house was filled with laughter and joy. My parents, despite their old age, had stayed up late just to welcome me. Their eyes sparkled with excitement and love as they embraced me.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table2.2.1.5', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table2.2.1.5.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '6  At that moment, all the weariness and frustration of the journey melted away. I realized that the true meaning of the Spring Festival lies in the love and connection we share with our family. It is a time to cherish the moments spent together and to create memories that will last a lifetime.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                        ],
                                                        textStyle: {

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },
                                            tableLabel3: {
                                                key: 'section3.1.3.1.1.1.table2.3', // *必填* 唯一标识
                                                type: 'input', // *必填* 类型：正文
                                                textStyle: {
                                                    textAlign:'left'
                                                },
                                            },
                                        },
                                        {
                                            tableLabel1: {
                                                key: 'section3.1.3.1.1.1.table3.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.1.1.1.table3.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'Part 3', // *必填* 文本内容
                                                        textStyle: {},
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },

                                            tableLabel2: {
                                                key: 'section3.1.3.1.1.1.table3.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    { // 气泡
                                                        key: 'section3.1.3.1.1.1.table3.2.1', // *必填* 唯一标识
                                                        category: 'popover', // *必填* 内容类型 text：文本
                                                        text: 'Para. 7-8', // *必填* 文本内容
                                                        inBody: 1,
                                                        // popTitle: '轴线的名词解释',
                                                        // popText: '',
                                                        content: [{
                                                                key: 'section3.1.3.1.1.1.table3.2.1.1', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table3.2.1.1.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '7  During the Spring Festival, I found myself enjoying the slower pace of life. I no longer felt rushed or anxious about the preparations. Instead, I embraced the opportunity to spend quality time with my parents. We made dumplings together, sharing stories and laughter as we worked. We sat around the table, enjoying delicious meals and engaging in heartfelt conversations.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {
                                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                                    // fontSize: 20, // 文字大小  默认：20
                                                                    // lineHeight: 40, // 行高  默认：36
                                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                                    // color: '#111', // 文本颜色  默认：#00a8ac
                                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                                },
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table3.2.1.2', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table3.2.1.2.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '8  The festive atmosphere was contagious. The streets were adorned with vibrant decorations, and the sound of firecrackers filled the air. I reunited with old friends and neighbors, exchanging well wishes and catching up on each other’s lives. We shared our hopes and dreams for the upcoming year, supporting and encouraging one another.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                        ],
                                                        textStyle: {

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },
                                            tableLabel3: {
                                                key: 'section3.1.3.1.1.1.table3.3', // *必填* 唯一标识
                                                type: 'input', // *必填* 类型：正文
                                                textStyle: {},
                                            },
                                        },
                                        {
                                            tableLabel1: {
                                                key: 'section3.1.3.1.1.1.table4.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.1.1.1.table4.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'Part 4', // *必填* 文本内容
                                                        textStyle: {},
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },

                                            tableLabel2: {
                                                key: 'section3.1.3.1.1.1.table4.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    { // 气泡
                                                        key: 'section3.1.3.1.1.1.table4.2.1', // *必填* 唯一标识
                                                        category: 'popover', // *必填* 内容类型 text：文本
                                                        text: 'Para. 9-10', // *必填* 文本内容
                                                        inBody: 1,
                                                        // popTitle: '轴线的名词解释',
                                                        // popText: '',
                                                        content: [{
                                                                key: 'section3.1.3.1.1.1.table4.2.1.1', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table4.2.1.1.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '9  As the days passed, I realized that the Spring Festival was not just a celebration of the past year but a hopeful anticipation of what lies ahead. It symbolized new beginnings and a chance for personal growth. It reminded me to let go of any past disappointments and embrace the possibilities of a brighter future.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {
                                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                                    // fontSize: 20, // 文字大小  默认：20
                                                                    // lineHeight: 40, // 行高  默认：36
                                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                                    // color: '#111', // 文本颜色  默认：#00a8ac
                                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                                },
                                                            },
                                                            {
                                                                key: 'section3.1.3.1.1.1.table3.2.1.2', // *必填* 唯一标识
                                                                type: 'text', // *必填* 类型：正文
                                                                isInTable: true,
                                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                                    {
                                                                        key: 'section3.1.3.1.1.1.table4.2.1.2.1', // *必填* 唯一标识
                                                                        category: 'text', // *必填* 内容类型 text：文本
                                                                        text: '10  What does the Spring Festival mean to me now? It is a time of reflection, gratitude, and renewed optimism. It is a reminder to cherish the love and warmth of family, to slow down, and to appreciate the simple joys in life. The Spring Festival has taught me that amid the chaos and challenges, there is always hope for a better tomorrow.', // *必填* 文本内容
                                                                        textStyle: {
                                                                            fontFamily: 'Calibri',
                                                                            fontSize: 26,
                                                                            lineHeight: 32, // 行高
                                                                        },
                                                                    },
                                                                ],
                                                                textStyle: {},
                                                            },
                                                        ],
                                                        textStyle: {

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontFamily: 'Calibri',
                                                    fontSize: 26,
                                                    lineHeight: 32, // 行高
                                                    fontItalic: 1,
                                                    textAlign: 'center',
                                                },
                                            },
                                            tableLabel3: {
                                                key: 'section3.1.3.1.1.1.table4.3', // *必填* 唯一标识
                                                type: 'input', // *必填* 类型：正文
                                                textStyle: {

                                                },
                                            },
                                        },
                                    ]
                                }],
                                title: "", // 标题
                                // width: 'xxxx', // 内容区域宽度 非必填 默认100%
                                titleStyle: {

                                }
                            },
                        ]
                    },
                    {
                        key: 'section3.1.3.2',
                        type: 'tab2',
                        text: 'Detailed Understanding',
                        width: 306,
                        borderBottom: 1,
                        borderRight: 0,
                        content: [{
                                key: 'section3.1.3.2.1',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: 'I',
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 15,
                                        marginLeft: 0,
                                        marginRight: 14,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                    popContent: { // 气泡
                                        key: 'section3.1.3.2.2', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        // text: '轴线', // *必填* 文本内容
                                        textSlot: 1, // 是否以插槽方式引入内容
                                        // popTitle: '轴线的名词解释',
                                        popText: '',
                                        content: [{
                                                key: 'section3.1.3.2.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '参考答案', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                                            fontWeight: 'bold'
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.2.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'anticipation', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.3', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.3.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'burden', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.4', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.4.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'long drive', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.5', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.5.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'a phone call', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.6', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.6.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'purpose', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.7', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.7.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'weariness and frustration', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.8', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.8.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'slower pace', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.9', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.9.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'optimism', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.2.2.10', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.2.10.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'the love', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            }
                                        ],
                                        textStyle: {

                                        },
                                    },
                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.3.2.1.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.3.2.1.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Read the text carefully and fill in the blanks.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Arial', // 字体，本地配置的字体
                                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            },
                                        }
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 38, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 19,
                                    marginBottom: 60,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                }
                            },
                            {
                                key: 'section3.1.3.2.2',
                                type: "title",
                                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "How the Author’s Attitude Toward the Spring Festival Changed", // *必填* 标题文本内容
                                textStyle: {
                                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                                    fontSize: 30, // 文字大小  默认：26
                                    lineHeight: 38, // 行高  默认：46
                                    textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#F0F8F5', // 背景颜色  默认：无
                                    // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
                                    width: '100%',
                                    marginTop: 0,
                                    padding: 34,
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                    borderRadius: 10
                                },
                            },
                            {
                                key: 'section3.1.3.2.3',
                                type: "title",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "The Author’s Original View on the Spring Festival", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    // height: 49,
                                    width: 'auto',
                                    paddingTop:15,
                                    paddingBottom:15,
                                    lineHeight: 32, // 行高  默认：46
                                    maxWidth: 500,
                                    // marginLeft: 20,
                                    // paddingLeft: 20,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    margin: 0,
                                    marginTop: 20,
                                    marginBottom: -60,
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },
                            // 模板样式 单个带边框
                            {
                                key: 'section3.1.3.2.4',
                                type: 'template',
                                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                                showReset: 1, // 是否展示重置按钮
                                templateStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#F0F8F5',
                                    width: '100%',
                                    marginTop: -60,
                                    // marginBottom: 30,
                                    padding: 34,
                                    paddingTop: 84,
                                    // paddingBottom: 0,
                                    borderRadius: 10,
                                    border: 'none',
                                    borderTop: 'none',
                                    borderBottom: 'none',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                },
                                content: [
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.4.1', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.4.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.4.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The Spring Festival symbolizes family reunion, happiness, and ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.4.1.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.4.1.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' for most people.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.4.2', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.4.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.4.2.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The Spring Festival can sometimes be a(n) ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.4.2.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.4.2.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' for most people.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.4.3', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.4.3.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.4.3.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The author questioned whether the hassle was worth it.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                key: 'section3.1.3.2.5',
                                type: "title",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "The Author’s Journey Home for the Spring Festival", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    // height: 49,
                                    paddingTop:15,
                                    paddingBottom:15,
                                    width: 'auto',
                                    lineHeight: 32, // 行高  默认：46
                                    maxWidth: 500,
                                    // marginLeft: 20,
                                    // paddingLeft: 20,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    margin: 0,
                                    marginTop: 20,
                                    marginBottom: -60,
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },
                            // 模板样式 单个带边框
                            {
                                key: 'section3.1.3.2.6',
                                type: 'template',
                                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                                showReset: 1, // 是否展示重置按钮
                                templateStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#F0F8F5',
                                    width: '100%',
                                    marginTop: -60,
                                    // marginBottom: 30,
                                    padding: 34,
                                    paddingTop: 84,
                                    // paddingBottom: 0,
                                    borderRadius: 10,
                                    border: 'none',
                                    borderTop: 'none',
                                    borderBottom: 'none',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                },
                                content: [
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.6.1', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.6.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.6.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.1.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.1.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' and expected traffic made the author feel fearful.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.6.2', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.6.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.6.2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The journey was difficult and frustrating, with little progress.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.6.3', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.6.3.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.6.3.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'As the author was about to lose hope, he/she received ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.3.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.3.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' from his/her parents.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.6.4', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.6.4.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.6.4.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The warm and loving words from the author’s parents gave him/her a sense of ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.4.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.6.4.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.6.5', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.6.5.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.6.5.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The author realized that the journey was for the sake of being with loved ones.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                key: 'section3.1.3.2.7',
                                type: "title",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "The Author’s Experiences During the Spring Festival", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    // height: 49,
                                    paddingTop:15,
                                    paddingBottom:15,
                                    width: 'auto',
                                    lineHeight: 32, // 行高  默认：46
                                    maxWidth: 500,
                                    // marginLeft: 20,
                                    // paddingLeft: 20,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    margin: 0,
                                    marginTop: 20,
                                    marginBottom: -60,
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },
                            // 模板样式 单个带边框
                            {
                                key: 'section3.1.3.2.8',
                                type: 'template',
                                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                                showReset: 1, // 是否展示重置按钮
                                templateStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#F0F8F5',
                                    width: '100%',
                                    marginTop: -60,
                                    // marginBottom: 30,
                                    padding: 34,
                                    paddingTop: 84,
                                    // paddingBottom: 0,
                                    borderRadius: 10,
                                    border: 'none',
                                    borderTop: 'none',
                                    borderBottom: 'none',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                },
                                content: [
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.8.1', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.8.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.8.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'His/Her parents welcomed him/her with excitement and love sparkled in their eyes.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.8.2', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.8.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.8.2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'His/Her ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.8.2.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.8.2.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' of the journey was swept away when his/her parents embraced him/her.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.8.3', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.8.3.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.8.3.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'He/She enjoyed the ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.8.3.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.8.3.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' of life and stopped feeling rushed or anxious about the preparations during the festival period.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.8.4', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.8.4.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.8.4.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'He/She reunited with old friends and neighbors, exchanged wishes, and learned about each other’s lives.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                key: 'section3.1.3.2.9',
                                type: "title",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "The Author’s View on the Spring Festival Now", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    // height: 49,
                                    paddingTop:15,
                                    paddingBottom:15,
                                    width: 'auto',
                                    lineHeight: 32, // 行高  默认：46
                                    maxWidth: 500,
                                    // marginLeft: 20,
                                    // paddingLeft: 20,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    margin: 0,
                                    marginTop: 20,
                                    marginBottom: -60,
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },
                            // 模板样式 单个带边框
                            {
                                key: 'section3.1.3.2.10',
                                type: 'template',
                                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                                showReset: 1, // 是否展示重置按钮
                                templateStyle: {
                                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                                    // fontSize: 38, // 文字大小  默认：26
                                    // lineHeight: 40, // 行高  默认：46
                                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#F0F8F5',
                                    width: '100%',
                                    marginTop: -60,
                                    // marginBottom: 30,
                                    padding: 34,
                                    paddingTop: 84,
                                    // paddingBottom: 0,
                                    borderRadius: 10,
                                    border: 'none',
                                    borderTop: 'none',
                                    borderBottom: 'none',
                                    borderLeft: 'none',
                                    borderRight: 'none',
                                },
                                content: [
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.10.1', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.10.1.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.10.1.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'The Spring Festival now means reflection, gratitude, and renewed ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.10.1.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.10.1.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                    // 列表
                                    {
                                        key: 'section3.1.3.2.10.2', // *必填* 唯一标识
                                        type: 'list', // *必填* 类型：视频
                                        templateType: 1, // *必填* 板式 1：ul
                                        content: [ // *必填* 列表内容
                                            {
                                                key: 'section3.1.3.2.10.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.2.10.2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: 'It’s a reminder to cherish ', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.10.2.1.2', // *必填* 唯一标识
                                                        category: 'input', // *必填* 内容类型 text：文本
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                    {
                                                        key: 'section3.1.3.2.10.2.1.3', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: ' and warmth of family.', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    fontSize: device.isMobile ? 28 : 24,
                                                    lineHeight: 40,
                                                    color: '#333', // 文本颜色  默认：#00a8ac
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                key: 'section3.1.3.2.11',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: 'II',
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 15,
                                        marginLeft: 0,
                                        marginRight: 14,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                    popContent: { // 气泡
                                        key: 'section3.1.3.11.2', // *必填* 唯一标识
                                        category: 'popover', // *必填* 内容类型 text：文本
                                        // text: '轴线', // *必填* 文本内容
                                        textSlot: 1, // 是否以插槽方式引入内容
                                        // popTitle: '轴线的名词解释',
                                        popText: '',
                                        content: [{
                                                key: 'section3.1.3.11.2.1', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.11.2.1.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '参考答案', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'MicrosoftYaHei', // 字体，本地配置的字体
                                                            fontWeight: 'bold'
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.11.2.2', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.11.2.2.2', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '1-5  T  F  F  T  T	', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // fontFamily: 'xxx', // 字体，本地配置的字体
                                                    // fontSize: 20, // 文字大小  默认：20
                                                    // lineHeight: 40, // 行高  默认：36
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                                                },
                                            },
                                            {
                                                key: 'section3.1.3.11.2.3', // *必填* 唯一标识
                                                type: 'text', // *必填* 类型：正文
                                                isInTable: true,
                                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                                    {
                                                        key: 'section3.1.3.11.2.3.1', // *必填* 唯一标识
                                                        category: 'text', // *必填* 内容类型 text：文本
                                                        text: '6-10  F  F  T  F  T', // *必填* 文本内容
                                                        textStyle: {
                                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                                            fontSize: '24px',

                                                        },
                                                    },
                                                ],
                                                textStyle: {
                                                    // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                                    color: '#111', // 文本颜色  默认：#00a8ac
                                                },
                                            }
                                        ],
                                        textStyle: {

                                        },
                                    },
                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.3.2.11.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.3.2.11.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Read the text carefully and decide whether the following statements are TRUE (T) or FALSE (F).', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Arial', // 字体，本地配置的字体
                                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            },
                                        }
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 38, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 19,
                                    marginBottom: 28,
                                    padding: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                }
                            },
                            {
                                key: 'section3.1.3.2.12',
                                type: 'trueOrFalse',
                                content: [{
                                        key: 'section3.1.3.2.12.1',
                                        text: 'The Spring Festival was sometimes a burden for the author.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.2',
                                        text: 'The author received a call from his/her parents who asked him/her to return home.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.3',
                                        text: 'The author’s journey home was not as hard as he/she had expected.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.4',
                                        text: 'The author was touched by the support and understanding from his/her parents on his/her way home.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.5',
                                        text: 'The author realized the true meaning of the Spring Festival when he/she returned home.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.6',
                                        text: 'The author didn’t like the slow pace of life and was often bored with the preparations during the holidays.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.7',
                                        text: 'The author liked to share his/her anxiety at work during the festivals.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.8',
                                        text: 'The author reunited with old friends and neighbors during the Spring Festival.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.9',
                                        text: 'The author’s friend told him/her to stay optimistic and learn to appreciate the simple pleasures in life.'
                                    },
                                    {
                                        key: 'section3.1.3.2.12.10',
                                        text: 'The Spring Festival reminded the author to lay down the disappointment and embrace a brighter future.'
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        key: 'section3.1.3.3',
                        type: 'tab2',
                        text: 'Critical thinking',
                        width: 220,
                        borderRight: 0,
                        content: [{
                                key: 'section3.1.3.3.1',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '',
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#fff', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 15,
                                        marginLeft: 0,
                                        marginRight: 14,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.3.3.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.3.3.1。1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Work in groups and discuss the following questions.', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Arial', // 字体，本地配置的字体
                                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                            },
                                        }
                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        // fontSize: 20, // 文字大小  默认：20
                                        // lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 50,
                                    padding: 0,
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                }
                            },
                            {
                                key: 'section3.1.3.3.2',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '1.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.3.3.2.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.3.3.2.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'Have you had a similar experience to the author?', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            {
                                key: 'section3.1.3.3.3',
                                type: "sound",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    height: 49,
                                    width: 'auto',
                                    lineHeight: 49, // 行高  默认：46
                                    maxWidth: 500,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },
                            {
                                key: 'section3.1.3.3.4',
                                type: 'paragraph',
                                category: 'withBefore',
                                leftMark: { // 左侧标记
                                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                                    width: 55,
                                    height: 40,
                                    text: '2.',
                                    textStyle: {
                                        fontFamily: 'Calibri', // 字体，本地配置的字体
                                        fontSize: 28, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333333', // 文本颜色  默认：#00a8ac
                                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                                        paddingLeft: 0,
                                        paddingRight: 5,
                                        marginLeft: 0,
                                        marginRight: 5,
                                        marginTop: 0,
                                        marginBottom: 0,
                                        top: 0,
                                        left: 0,
                                    },

                                },
                                content: { //右侧文本内容，目前只有一段文字
                                    key: 'section3.1.3.3.4.1', // *必填* 唯一标识
                                    type: 'text', // *必填* 类型：正文
                                    isInTable: true,
                                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                        {
                                            key: 'section3.1.3.3.4.1.1', // *必填* 唯一标识
                                            category: 'text', // *必填* 内容类型 text：文本
                                            text: 'What special experience have you had during the Spring Festival?', // *必填* 文本内容
                                            textStyle: {
                                                fontFamily: 'Calibri', // 字体，本地配置的字体

                                            },
                                        },

                                    ],
                                    textStyle: {
                                        // fontFamily: 'xxx', // 字体，本地配置的字体
                                        fontSize: 24, // 文字大小  默认：20
                                        lineHeight: 40, // 行高  默认：36
                                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                        color: '#333', // 文本颜色  默认：#00a8ac
                                        backgroundColor: '#EAF4F0', // 背景颜色  默认：无
                                    },
                                },
                                // 段落内外间距
                                paragraphStyle: {
                                    marginTop: 0,
                                    marginBottom: 10,
                                    padding: 0,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    backgroundColor: "#EAF4F0",
                                }
                            },
                            {
                                key: 'section3.1.3.3.5',
                                type: "sound",
                                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                                text: "", // *必填* 标题文本内容
                                titleImageType: 3,
                                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                                textStyle: {
                                    fontFamily: 'Arial', // 字体，本地配置的字体
                                    fontSize: 26, // 文字大小  默认：26
                                    height: 49,
                                    width: 'auto',
                                    lineHeight: 49, // 行高  默认：46
                                    maxWidth: 500,
                                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                                    color: '#fff', // 文本颜色  默认：#00a8ac
                                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                                    borderRadius: {
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 20,
                                        borderBottomLeftRadius: 0
                                    }
                                },
                            },

                        ]
                    },

                ]
            }
        ],
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 30,
            // marginBottom: 30,
            // padding: 0,
            // paddingTop: 0,
            // paddingBottom: 0,
            // borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        }
    },

]
export default content